import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { InsuranceApi } from '../tokens/insurance.token';
import { AttachInsuranceRequest, InsurancePolicy } from '../models/financing-servicing.model';

/**
 * REST-only implementation of `InsuranceApi` (EPIC-4 / EM-500, Story 10 — EM-510).
 *
 * Calls the Story-7 `InsuranceResource` (loan-/policy-id-keyed). The list + attach + opt-out are
 * loan-id-keyed under `/services/embedded/api/loans/{loanId}/insurance`; the PDF stream is
 * policy-id-keyed under `/services/embedded/api/insurance/policies/{policyId}/pdf`. Rides the
 * Keycloak bearer. Rule 07 / Rule 10 — no Mock. Rule 09 — errors propagate (a mandated policy
 * opt-out → 403).
 */
@Injectable()
export class InsuranceRestService implements InsuranceApi {
  private readonly http = inject(HttpClient);

  list(loanId: string): Observable<InsurancePolicy[]> {
    return this.http.get<InsurancePolicy[]>(`${API_PATHS.LOANS}/${encodeURIComponent(loanId)}/insurance`);
  }

  attach(loanId: string, request: AttachInsuranceRequest): Observable<InsurancePolicy> {
    return this.http.post<InsurancePolicy>(
      `${API_PATHS.LOANS}/${encodeURIComponent(loanId)}/insurance/attach`,
      request,
    );
  }

  optOut(loanId: string, policyId: number): Observable<void> {
    return this.http.delete<void>(`${API_PATHS.LOANS}/${encodeURIComponent(loanId)}/insurance/${policyId}`);
  }

  pdf(policyId: number): Observable<Blob> {
    return this.http.get(`${API_PATHS.INSURANCE_POLICIES}/${policyId}/pdf`, { responseType: 'blob' });
  }
}
